module.exports = __webpack_public_path__ + "static/img/tooltip-phased-orbit-finder.bc80f65.png";